/**
 * Menvora — timeline «confirmar pedido» (form COD).
 * Reemplaza .rsi-form-navigation-wrapper o prepend en .rsi-form-content-wrapper.
 */
(function () {
  if (window.__menvoraCodConfirmTimeline) return;
  window.__menvoraCodConfirmTimeline = true;

  var NAV_SEL =
    '.rsi-form-content-wrapper > .rsi-form-navigation-wrapper, .rsi-form-navigation-wrapper';
  var CONTENT_SEL = '.rsi-form-content-wrapper';
  var TZ = 'America/Mexico_City';
  var MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  var DELIVER_MIN = 5;
  var DELIVER_MAX = 7;
  var formEl = null;
  var formWatchTimer = 0;
  var formObserver = null;

  function todayYmdCdmx() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    var out = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') out[parts[i].type] = parts[i].value;
    }
    return out.year + '-' + out.month + '-' + out.day;
  }

  function parseYmd(ymd) {
    var bits = String(ymd).split('-');
    return new Date(Date.UTC(+bits[0], +bits[1] - 1, +bits[2], 12, 0, 0));
  }

  function addDays(ymd, n) {
    var dt = parseYmd(ymd);
    dt.setUTCDate(dt.getUTCDate() + n);
    return (
      dt.getUTCFullYear() +
      '-' +
      String(dt.getUTCMonth() + 1).padStart(2, '0') +
      '-' +
      String(dt.getUTCDate()).padStart(2, '0')
    );
  }

  function rangeLabel(startYmd, endYmd) {
    var a = parseYmd(startYmd);
    var b = parseYmd(endYmd);
    var d1 = a.getUTCDate();
    var d2 = b.getUTCDate();
    var m1 = MONTHS[a.getUTCMonth()];
    var m2 = MONTHS[b.getUTCMonth()];
    if (m1 === m2 && a.getUTCFullYear() === b.getUTCFullYear()) {
      return d1 + '-' + d2 + ' ' + m1;
    }
    return d1 + ' ' + m1 + '–' + d2 + ' ' + m2;
  }

  function computeDates(anchorYmd) {
    var order = anchorYmd || todayYmdCdmx();
    return {
      order: order,
      deliverLabel: rangeLabel(addDays(order, DELIVER_MIN), addDays(order, DELIVER_MAX)),
    };
  }

  function setLabel(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function findShippingSection() {
    var wrap = document.getElementById('rsi_form_wrapper');
    if (!wrap) return null;
    var nodes = wrap.querySelectorAll('p.rsi-custom-text, .rsi-custom-text');
    for (var i = 0; i < nodes.length; i++) {
      var text = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^2\.\s*Datos de Entrega$/i.test(text)) return nodes[i];
    }
    return null;
  }

  function scrollToShippingSection() {
    var target = findShippingSection();
    if (!target) return;
    try {
      target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    } catch (err) {
      try {
        target.scrollIntoView(true);
      } catch (e2) { /* noop */ }
    }
  }

  function bindDeliveryOk(root) {
    var btn = root && root.querySelector('[data-mcct-delivery-ok]');
    if (!btn || btn.getAttribute('data-mcct-bound') === '1') return;
    btn.setAttribute('data-mcct-bound', '1');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToShippingSection();
    });
  }

  function fillDelivery(root) {
    if (!root) return;
    var dates = computeDates();
    if (window.MenvoraDeliveryTimeline && window.MenvoraDeliveryTimeline.computeDates) {
      dates = window.MenvoraDeliveryTimeline.computeDates();
    }
    var text = 'Pide hoy - Recibe ' + dates.deliverLabel;
    if (root.getAttribute('data-mcct-dates-key') === text) return;
    setLabel(root.querySelector('[data-mcct-delivery-label]'), text);
    root.setAttribute('data-mcct-dates-key', text);
  }

  function cloneTimeline() {
    var tpl = document.getElementById('menvora-cod-confirm-timeline-tpl');
    if (!tpl || !tpl.content) return null;
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.classList.add('menvora-cod-confirm-timeline--form');
    node.setAttribute('data-menvora-cod-confirm-placement', 'form');
    fillDelivery(node);
    bindDeliveryOk(node);
    return node;
  }

  function needsUpgrade(root) {
    return !root || !root.querySelector('[data-mcct-delivery-label]');
  }

  function findFormTimeline(wrap) {
    if (!wrap) return null;
    return wrap.querySelector(
      '.menvora-cod-confirm-timeline--form, [data-menvora-cod-confirm-placement="form"]'
    );
  }

  function isFormVisible(wrap) {
    if (!wrap) return false;
    if (document.body.classList.contains('menvora-cod-form-open')) return true;
    var cs = window.getComputedStyle(wrap);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) {
      return false;
    }
    return wrap.getBoundingClientRect().height > 40;
  }

  function isShown(el) {
    if (!el || !el.isConnected) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) {
      return false;
    }
    return el.getBoundingClientRect().height > 24;
  }

  function isUpsellVisible(wrap) {
    var nodes = wrap.querySelectorAll('.rsi-upsell-container');
    for (var i = 0; i < nodes.length; i++) {
      if (isShown(nodes[i])) return true;
    }
    return false;
  }

  function isCheckoutFormVisible(wrap) {
    var field = wrap.querySelector('#first_name, #phone, input[name="first_name"]');
    if (!field) return false;
    var row = field.closest('.rsi-text-input-row') || field;
    return isShown(row);
  }

  function unmountFormTimeline(wrap) {
    var existing = findFormTimeline(wrap);
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    formEl = null;
  }

  function isMountedStable(wrap) {
    var existing = findFormTimeline(wrap);
    return !!(existing && existing.isConnected && !needsUpgrade(existing));
  }

  function findMountPoint(wrap) {
    var nav = wrap.querySelector(NAV_SEL);
    if (nav && nav.parentNode) {
      return { mode: 'replace', parent: nav.parentNode, target: nav };
    }
    var content = wrap.querySelector(CONTENT_SEL);
    if (content) {
      return { mode: 'prepend', parent: content, target: content.firstElementChild };
    }
    return null;
  }

  function mountForm() {
    var wrap = document.getElementById('rsi_form_wrapper');
    if (!wrap || !isFormVisible(wrap)) return false;
    if (isUpsellVisible(wrap) || !isCheckoutFormVisible(wrap)) {
      unmountFormTimeline(wrap);
      return false;
    }

    var existing = findFormTimeline(wrap);
    if (existing && existing.isConnected) {
      if (needsUpgrade(existing)) {
        var upgraded = cloneTimeline();
        if (upgraded && existing.parentNode) {
          try {
            existing.parentNode.replaceChild(upgraded, existing);
            formEl = upgraded;
            return true;
          } catch (err) {
            return false;
          }
        }
      }
      fillDelivery(existing);
      bindDeliveryOk(existing);
      formEl = existing;
      return true;
    }

    var point = findMountPoint(wrap);
    if (!point) return false;

    var node = cloneTimeline();
    if (!node) return false;

    try {
      if (point.mode === 'replace') {
        point.parent.replaceChild(node, point.target);
      } else {
        point.parent.insertBefore(node, point.target);
      }
    } catch (err) {
      return false;
    }

    formEl = node;
    return true;
  }

  function scheduleMount() {
    mountForm();
    window.setTimeout(mountForm, 80);
    window.setTimeout(mountForm, 350);
    window.setTimeout(mountForm, 900);
  }

  function stopWatch() {
    if (!formWatchTimer) return;
    window.clearInterval(formWatchTimer);
    formWatchTimer = 0;
  }

  function startWatch() {
    if (formWatchTimer) return;
    formWatchTimer = window.setInterval(function () {
      var wrap = document.getElementById('rsi_form_wrapper');
      if (!wrap) {
        formEl = null;
        return;
      }
      if (!isFormVisible(wrap)) return;
      if (isUpsellVisible(wrap) || !isCheckoutFormVisible(wrap)) {
        unmountFormTimeline(wrap);
        return;
      }
      if (isMountedStable(wrap)) {
        formEl = findFormTimeline(wrap);
        bindDeliveryOk(formEl);
        return;
      }
      mountForm();
    }, 500);
  }

  function observeForm(wrap) {
    if (!wrap || formObserver) return;
    formObserver = new MutationObserver(function () {
      if (!isFormVisible(wrap)) return;
      if (isUpsellVisible(wrap) || !isCheckoutFormVisible(wrap)) {
        unmountFormTimeline(wrap);
        return;
      }
      if (!isMountedStable(wrap)) scheduleMount();
    });
    formObserver.observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
  }

  function watchFormInjection() {
    if (typeof MutationObserver !== 'function') return;
    var bootMo = new MutationObserver(function () {
      var wrap = document.getElementById('rsi_form_wrapper');
      if (!wrap) return;
      observeForm(wrap);
      if (isFormVisible(wrap)) scheduleMount();
    });
    bootMo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    if (!document.getElementById('menvora-cod-confirm-timeline-tpl')) return;

    startWatch();
    watchFormInjection();

    var existingWrap = document.getElementById('rsi_form_wrapper');
    if (existingWrap) observeForm(existingWrap);

    window.addEventListener('menvora:cod-form-chrome', function (ev) {
      if (!ev.detail || !ev.detail.open) return;
      scheduleMount();
      startWatch();
    });

    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (!t.closest('#rsi_buy_now_button, #floatingBuyNowButton, [data-rsi-cod-button="true"]')) {
          return;
        }
        scheduleMount();
        startWatch();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
